import * as React from "react";
import * as _ from "lodash";
import {FormElement, AbstractInputElement} from "./FormInput";


export class FormTextArea extends AbstractInputElement<string, FormElement<string, HTMLTextAreaElement>, {}> {

    getDefaultValue(): string {
        return "";
    }

    render() {
        let rest = _.omit(this.props, ['validators', `model`, `fieldSet`, `modelValue`, `valid`, 'validationMap']);
        return <textarea {...rest} className={this.getClassNames()} value={this.getModelValue()}
                         onChange={this.handleChange.bind(this)}></textarea>
    }

}




// WEBPACK FOOTER //
// ./src/app/ui/form/FormTextArea.tsx